import Request from "../../../services/requests";
import {handleUnauthorizedAction, setAuthenticationAction} from "../../../redux/actions/setAuthAction";
export function isAuthorizedToken() {
    let r = new Request();
    return r.get('auth/access-token', null, setAuthenticationAction, handleUnauthorizedAction)
}
